import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const AddEditWorkHistoryJobModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "AddEditWorkHistoryJobModalContainer" */
      './AddEditWorkHistoryJobModalContainer'
    ),
  loading: LoadingModal,
});
